import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseItem } from '@guillotinaweb/grange-core'
import { ManageProjectXlistsDialogComponent } from '../manage-project-xlists-dialog/manage-project-xlists-dialog.component'

@Component({
  selector: 'app-manage-project-delete-xlist-dialog',
  templateUrl: './manage-project-delete-xlist-dialog.component.html',
  styleUrls: ['./manage-project-delete-xlist-dialog.component.scss'],
})
export class ManageProjectDeleteXlistDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ManageProjectXlistsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pack: BaseItem }
  ) {}

  ngOnInit(): void {}

  public close(ok: boolean) {
    this.dialogRef.close({ ok, pack: this.data.pack })
  }
}
